module.exports = __webpack_public_path__ + "img/1a2627bd-61e0-406a-9308-19f2883d004e.aef2a76c.webp";